import { render, staticRenderFns } from "./BulkLand.vue?vue&type=template&id=e97b6ec2&"
import script from "./BulkLand.vue?vue&type=script&lang=js&"
export * from "./BulkLand.vue?vue&type=script&lang=js&"
import style0 from "./BulkLand.vue?vue&type=style&index=0&id=e97b6ec2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports